<template lang="pug">
.m-card
  .m-card-header(:id="'heading-dcou-' + id" :data-bs-target="'#collapse-dcou-' + id" :aria-controls="'collapse-dcou-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_DCOU", 1) }}
  .m-card-body.collapse.show(:id="'collapse-dcou-' + id" :aria-labelledby="'heading-dcou-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T  
          .odds-group
            template(v-for="item in col")
              template(v-if="moreItems['dcouo'][item] && moreItems['dcouo'][item][5] != 0 && moreItems['dcouo'][item][5] != ''")
                OddsItem.col-more-scroll(:odds="moreItems['dcouo'][item]" idx=5 :typ="oddsType" dataType="3" :label="getLabel(item)")
              template(v-else)
                OddsDisabled.col-more-scroll
//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-dcou-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-dcou-' + id"
//-     :aria-controls="'collapse-dcou-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_DCOU") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-dcou-' + id"
//-     :id="'collapse-dcou-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group(v-for="item in col")
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_" + item) }} ({{ moreItems['dcouo'][item][7] }})
//-               template(v-if="moreItems['dcouo'][item] && moreItems['dcouo'][item][5] != 0 && moreItems['dcouo'][item][5] != ''")
//-                 OddsItem(:odds="moreItems['dcouo'][item]" idx=5 :typ="oddsType" dataType="3" :details="moreItems" mode="dcouo")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      col: ["HDO", "HDU", "HAO", "HAU", "DAO", "DAU"],
    }
  },
  methods: {
    getLabel(x) {
      if(this.moreItems['dcouo'][x] && this.moreItems['dcouo'][x][7] && this.moreItems['dcouo'][x][7] != '') {
        return this.$t("m.BT_" + x) + ' (' + this.moreItems['dcouo'][x][7] + ')';
      }
      return this.$t("m.BT_" + x);
    },
  }
}
</script>
